export const meKeys = {
	preferences: ["me", "preferences"],
};
